import React, { type FC, type ReactNode, memo, useMemo } from "react";
import { BottomSheetScrollView, type BottomSheetModal } from "@gorhom/bottom-sheet";
import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useWindowDimensions } from "react-native";
import { AppBottomSheet } from "@src/features/common/components/AppBottomSheet";

interface ScrollableBottomSheetProps {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  children: ReactNode;
  snapHeightFraction?: number;
}

export const ScrollableBottomSheet: FC<ScrollableBottomSheetProps> = memo(
  ({ bottomSheetRef, children, snapHeightFraction = 0.65 }) => {
    const { theme } = useUnistyles();
    const { bottom: safeAreaBottom } = useSafeAreaInsets();
    const { height: screenHeight } = useWindowDimensions();

    const snapPoints = useMemo(() => {
      const availableHeight = screenHeight - safeAreaBottom;
      return [availableHeight * snapHeightFraction];
    }, [screenHeight, safeAreaBottom, snapHeightFraction]);

    return (
      <AppBottomSheet
        bottomSheetRef={bottomSheetRef}
        snapPoints={snapPoints}
        enableDynamicSizing={false}
        backgroundStyle={{ backgroundColor: theme.colors.background }}
      >
        <BottomSheetScrollView>
          <View flex={1} px="5xl" pt="lg" pb="3xl">
            {children}
            <View style={{ height: safeAreaBottom }} />
          </View>
        </BottomSheetScrollView>
      </AppBottomSheet>
    );
  },
);
